import { RegionId } from "./RegionId";

export const Cultures = {
  Danish: "da-DK",
  Finnish: "fi-FI",
  Norwegian: "nb-NO",
  FinnishSwedish: "sv-FI",
  Swedish: "sv-SE",
  German: "de-DE",
  Spanish: "es-ES",
} as const;

export type Culture = (typeof Cultures)[keyof typeof Cultures];

export const regionIdToCulture = (regionId: RegionId) => {
  switch (regionId) {
    case RegionId.Denmark:
      return Cultures.Danish;
    case RegionId.Finland:
      return Cultures.Finnish;
    case RegionId.Norway:
      return Cultures.Norwegian;
    case RegionId.Sweden:
      return Cultures.Swedish;
    case RegionId.Germany:
      return Cultures.German;
    case RegionId.Spain:
      return Cultures.Spanish;
    case RegionId.None:
      return undefined;
    default:
      return undefined;
  }
};

export const cultureToRegionId = (culture: Culture | undefined): RegionId => {
  switch (culture) {
    case Cultures.Danish:
      return RegionId.Denmark;
    case Cultures.Finnish:
      return RegionId.Finland;
    case Cultures.FinnishSwedish:
      return RegionId.Finland;
    case Cultures.Norwegian:
      return RegionId.Norway;
    case Cultures.Swedish:
      return RegionId.Sweden;
    case Cultures.German:
      return RegionId.Germany;
    case Cultures.Spanish:
      return RegionId.Spain;
    default:
      return RegionId.Norway;
  }
};
